export default {"src":"/_next/static/media/WARNING_TRIANGLE_RED.afc5b7d3.svg","height":11,"width":12,"blurWidth":0,"blurHeight":0};